import { NotificationManager } from "react-notifications";

const uri = process.env.API_USER_GUIDE;

export function getUserGuide(fileName) {
  return fetch(`${uri}/downloadfile?fileName=${fileName}`, {
    headers: {
      "Content-Type": "application/json; charset=utf8",
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return res.blob();
      }
    })
    .then((data) => {
      const blobUrl = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl); // Libera la URL de objeto después de usarla
      document.body.removeChild(a); // Elimina el elemento "a" del DOM
    })
    .catch((error) => {
      console.error("Error in downloading", error);
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
}

export function uploadUserGuide(file, moduleId, resourceType) {
  let formdata = new FormData();
  formdata.append("inputFile", file);
  formdata.append("categoryName", moduleId);
  formdata.append("ResourceType", resourceType);
  let requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
    headers: {},
  };
  return fetch(`${uri}/uploadResource`, requestOptions)
    .then((response) => response.text())
    .catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
}